import { render, staticRenderFns } from "./_memberProfile.vue?vue&type=template&id=4791f3c1&scoped=true&lang=pug&"
import script from "./_memberProfile.vue?vue&type=script&lang=js&"
export * from "./_memberProfile.vue?vue&type=script&lang=js&"
import style0 from "./_memberProfile.vue?vue&type=style&index=0&id=4791f3c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4791f3c1",
  null
  
)

export default component.exports